import keuangan from './keuangan'

export default [
  ...keuangan,
]
